/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  selectedPlan: '',
  rebateProgram: [],
  errorMsgDrugSummary: [],
  quarterFrom: '',
  rebateProgramName: '',
  cms: [],
  drug: [],
  drugCms: [],
  displayObj: {
    contactsDropValue: '',
    rebateProgramName: {},
    cms: [],
    drug: [],
    drugCms: [],
    quarterFrom: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_SUMMARY:
      return { ...state, performDisputeResolutionObj: action.screenData };
    case actionTypes.GET_PLAN_TYPE_DATA_SUMMARY:
      return { ...state, planType: action.payload };
    case actionTypes.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionTypes.GET_ERROR_MSG_DRUG_SUMMARY:
      return { ...state, errorMsgDrugSummary: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_SUMMARY:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_DRUG:
      return { ...state, rebateProgram: action.dropdown };
    case actionTypes.SET_DISPLAY_OBJ_SUMMARY:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_CMS_DRUG_TYPE_SUMMARY:
      let displayObj = {
        ...state.displayObj,
        cms: action.payload,
      };
      return { ...state, cms: action.payload, displayObj };

    case actionTypes.GET_DRUG_TYPE_DRUG_SUMMARY:
      let displayObj1 = {
        ...state.displayObj,
        drug: action.payload,
      };
      return { ...state, drug: action.payload, displayObj: displayObj1 };

    case actionTypes.GET_DRUG_CMS_TYPE_SUMMARY:
      let displayObj2 = {
        ...state.displayObj,
        drugCms: action.payload,
      };
      return { ...state, drugCms: action.payload, displayObj: displayObj2 };

    case actionTypes.GET_FROM:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.SET_REFRESH_DATA_DRUG:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        selectedPlan: '',
        rebateProgram: [],
        errorMsgDrugSummary: [],
        quarterFrom: '',
        rebateProgramName: '',
        cms: [],
        drug: [],
        drugCms: [],
      };
    case actionTypes.SET_REFRESH_DATA_DRUG_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
